var CsAgGridJsModule = /** @class */ (function () {
    function CsAgGridJsModule() {
    }
    return CsAgGridJsModule;
}());
export { CsAgGridJsModule };
